import { type DirectiveBinding, type ObjectDirective } from 'vue';
import { useAuthStore } from '~/store/auth';

// Extend the DirectiveBinding interface to include a value of string array
interface RoleDirectiveBinding extends DirectiveBinding {
    value: string[];
}

const RoleDirective: ObjectDirective<HTMLElement, string[]> = {
    // Use the mounted lifecycle hook to manipulate the DOM
    mounted(el, binding: RoleDirectiveBinding) {
        const requiredRoles = binding.value;
        const authStore = useAuthStore();

        // Check if the authStore exists and the value is an array
        if (!authStore || !Array.isArray(requiredRoles)) {
            // Remove the element from the DOM if authStore or requiredRoles is not valid
            el.parentNode?.removeChild(el);
            return;
        }

        // Check if the user has at least one of the required roles
        const hasRequiredRoles = requiredRoles.some((role) => authStore.hasRole(role));

        // Remove the element from the DOM if the user does not have the required roles
        if (!hasRequiredRoles) {
            el.parentNode?.removeChild(el);
        }
    },
};

export default RoleDirective;
